import React from 'react';

/**
 * Breadcrumb / page-title strip below the main nav was removed for a cleaner header
 * (nav + page content only). Restore from git history if needed.
 */
const I3PageHeader: React.FC = () => {
  return null;
};

export default I3PageHeader;
